import { client } from './client'

export default {
  index () {
    return client.get('/decoders')
  }
}



// WEBPACK FOOTER //
// ./src/api/decoder.js